import React from "react";
import Navigation from "./Navigation";
import HeroSection from "./HeroSection";
import AboutMe from "./AboutMe";
import PortfolioFooter from "./PortfolioFooter";
import TestimonialsSection from "./TestimonialsSection";
import ContactSection from "./ContactSection";
import WebsiteFooter from "./WebsiteFooter";

function App() {
  return (
    <>
      <Navigation />
      <HeroSection />
      <AboutMe />
      <PortfolioFooter />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "3rem",
          maxWidth: 1200,
          margin: "0rem auto 0 auto",
          padding: "0 1rem",
          justifyContent: "center",
        }}
      >
        <div style={{ minWidth: 320, maxWidth: 540, width: "100%" }}>
          <TestimonialsSection />
        </div>
        <div style={{ minWidth: 320, maxWidth: 540, width: "100%" }}>
          <ContactSection />
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
}

export default App;
